import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { toCreditCostRequestPayload } from './mappers/creditCostQuoteMapper';
import type { CreditConfirmationResponse, CreditCostRequest } from './types';

type CreateCreditConfirmationProps = {
  artistId: string;
  request: CreditCostRequest;
  // The total the leader saw; the server refuses a higher price and stores its own.
  credits: number;
};

export const createCreditConfirmation = async ({ artistId, request, credits }: CreateCreditConfirmationProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/credit-confirmations`;

  const response = await api.executePostRequest<ObjectResponse<CreditConfirmationResponse>>(url, {
    ...toCreditCostRequestPayload(request),
    credits,
  });

  return response.data;
};
